(function () {
  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.from((root || document).querySelectorAll(sel)); }

  function isAllowedPhoto(file) {
    if (!file) return false;

    const name = (file.name || '').toLowerCase();

    const okMime =
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'image/heic' ||
      file.type === 'image/heif' ||
      file.type === '';

    const okExt =
      name.endsWith('.jpg') ||
      name.endsWith('.jpeg') ||
      name.endsWith('.png') ||
      name.endsWith('.heic') ||
      name.endsWith('.heif');

    return okMime || okExt;
  }

  function isHeicFile(file) {
    if (!file) return false;
    const name = (file.name || '').toLowerCase();
    return (
      file.type === 'image/heic' ||
      file.type === 'image/heif' ||
      name.endsWith('.heic') ||
      name.endsWith('.heif')
    );
  }

  async function convertHeicIfNeeded(file) {
    if (!isHeicFile(file)) return file;

    if (typeof window.heic2any !== 'function') {
      throw new Error('heic2any is niet geladen');
    }

    const result = await window.heic2any({
      blob: file,
      toType: 'image/jpeg',
      quality: 0.92
    });

    const blob = Array.isArray(result) ? result[0] : result;
    const newName = (file.name || 'upload.heic').replace(/\.(heic|heif)$/i, '.jpg');

    return new File([blob], newName, {
      type: 'image/jpeg',
      lastModified: Date.now()
    });
  }

  function init(root) {
    // ---------- Variant (Klein/Groot)
    const sizeBtns = qsa(root, '[data-lf-size-btn]');
    const variantMap = qs(root, '[data-lf-variants]');
    const variantKlein = variantMap?.getAttribute('data-variant-klein') || '';
    const variantGroot = variantMap?.getAttribute('data-variant-groot') || '';
    let selectedSize = 'klein';

    function setSize(size) {
      selectedSize = (size === 'groot') ? 'groot' : 'klein';
      sizeBtns.forEach(b => b.classList.toggle('is-active', b.dataset.size === selectedSize));
    }

    sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => setSize(btn.dataset.size));
    });

    // ---------- Frame swatches + naam
    const swatchBtns = qsa(root, '[data-lf-swatch]');
    const frameEl = qs(root, '[data-lf-frame]');
    const colorNameEl = qs(root, '[data-lf-color-name]');
    let selectedFrameColor = '#000000';
    let selectedFrameName = 'Zwart';

    function setFrameColor(color) {
      selectedFrameColor = color || '#000000';

      if (frameEl) frameEl.style.setProperty('--frame', selectedFrameColor);

      let activeName = 'Zwart';
      swatchBtns.forEach(btn => {
        const isActive = btn.dataset.color === selectedFrameColor;
        btn.classList.toggle('is-active', isActive);
        if (isActive) activeName = btn.dataset.name || activeName;
      });

      selectedFrameName = activeName;
      if (colorNameEl) colorNameEl.textContent = activeName;
    }

    swatchBtns.forEach(btn => {
      btn.addEventListener('click', () => setFrameColor(btn.dataset.color));
    });

    setSize('klein');
    setFrameColor('#000000');

    // ---------- Modal
    const openBtn = qs(root, '[data-lf-open]');
    const modal = qs(root, '[data-lf-modal]');
    const backdrop = qs(root, '[data-lf-backdrop]');
    const closeBtn = qs(root, '[data-lf-close]');

    if (!openBtn || !modal) return;

    let scrollY = 0;

    function openModal() {
      modal.classList.add('is-open');

      scrollY = window.scrollY || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function closeModal() {
      modal.classList.remove('is-open');

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }

    openBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    // ---------- Upload + preview
    const file1 = qs(root, '[data-lf-file1]');
    const pickBtn = qs(root, '[data-lf-pick]');
    const fileNameEl = qs(root, '[data-lf-file-name]');
    const hint1 = qs(root, '[data-lf-hint1]');
    const img1 = qs(root, '[data-lf-img1]');
    const addBtn = qs(root, '[data-lf-add]');
    const note = qs(root, '[data-lf-note]');
    const removeBtn = qs(root, '[data-lf-remove]');

    if (!file1 || !addBtn) return;

    const MAX_MB = 15;
    const MAX_BYTES = MAX_MB * 1024 * 1024;

    let currentObjectUrl = null;
    let convertedUploadFile = null; // voor HEIC -> JPG als browser dit toelaat

    function validate() {
      const hasOriginal = file1.files && file1.files[0];
      addBtn.disabled = !hasOriginal;
      if (removeBtn) removeBtn.style.display = hasOriginal ? 'block' : 'none';
    }

    function cleanupPreviewUrl() {
      if (currentObjectUrl) {
        URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = null;
      }
    }

    function resetPhoto() {
      cleanupPreviewUrl();
      convertedUploadFile = null;

      file1.value = '';
      if (fileNameEl) fileNameEl.textContent = 'Geen bestand gekozen';

      if (img1) {
        img1.removeAttribute('src');
        img1.style.display = 'none';
      }

      if (hint1) hint1.textContent = '';
      if (note) note.textContent = '';

      validate();
    }

    async function readPreview(file) {
      if (!file) return;

      if (file.size > MAX_BYTES) {
        if (hint1) hint1.textContent = `Bestand te groot. Max ${MAX_MB}MB toegestaan.`;
        resetPhoto();
        return;
      }

      if (!isAllowedPhoto(file)) {
        if (hint1) hint1.textContent = 'Alleen JPG, JPEG, PNG of HEIC toegestaan.';
        resetPhoto();
        return;
      }

      if (hint1) hint1.textContent = '';
      if (note) note.textContent = '';

      cleanupPreviewUrl();

      try {
        let previewFile = file;
        convertedUploadFile = null;

        // HEIC -> JPG voor preview
        if (isHeicFile(file)) {
          previewFile = await convertHeicIfNeeded(file);
          convertedUploadFile = previewFile;

          // Probeer geconverteerde file terug in input te zetten
          try {
            const dt = new DataTransfer();
            dt.items.add(previewFile);
            file1.files = dt.files;
          } catch (e) {
            // Op sommige mobiele browsers lukt dit niet.
            // Dan laten we de originele HEIC in het input veld staan,
            // maar tonen we wel netjes de JPG preview.
          }

          if (fileNameEl) fileNameEl.textContent = previewFile.name;
        }

        currentObjectUrl = URL.createObjectURL(previewFile);

        if (img1) {
          img1.src = currentObjectUrl;
          img1.style.display = 'block';
        }

        validate();
      } catch (error) {
        console.error('Preview/conversie mislukt:', error);

        // Als HEIC conversie faalt, laat duidelijke melding zien
        if (isHeicFile(file)) {
          if (hint1) hint1.textContent = 'Deze HEIC-foto kon niet worden geladen. Probeer een andere foto of exporteer als JPG.';
          resetPhoto();
          return;
        }

        // fallback voor gewone JPG/PNG
        try {
          currentObjectUrl = URL.createObjectURL(file);
          if (img1) {
            img1.src = currentObjectUrl;
            img1.style.display = 'block';
          }
          validate();
        } catch (e2) {
          if (hint1) hint1.textContent = 'De foto kon niet worden geladen.';
          resetPhoto();
        }
      }
    }

    function getProductForm() {
      return document.querySelector('form[action*="/cart/add"]');
    }

    // Zet file input meteen in de form bij init
    const productForm = getProductForm();
    if (productForm && file1 && !file1.closest('form')) {
      productForm.appendChild(file1);
    }

    function ensureHidden(form, name, value) {
      let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = value;
    }

    function addToCart() {
      const form = getProductForm();
      if (!form) {
        if (note) note.textContent = 'Product form niet gevonden.';
        return;
      }

      const file = file1.files && file1.files[0];
      if (!file) {
        if (note) note.textContent = 'Upload eerst een foto.';
        return;
      }

      if (!isAllowedPhoto(file)) {
        if (note) note.textContent = 'Alleen JPG, JPEG, PNG of HEIC toegestaan.';
        return;
      }

      const chosenVariant = (selectedSize === 'groot') ? variantGroot : variantKlein;
      if (!chosenVariant) {
        if (note) note.textContent = 'Variant niet gevonden. Check of varianten Klein/Groot bestaan.';
        return;
      }

      ensureHidden(form, 'id', chosenVariant);
      ensureHidden(form, 'properties[Lijstkleur]', selectedFrameName);
      ensureHidden(form, 'properties[Lijstkleur code]', selectedFrameColor);
      ensureHidden(form, 'properties[Formaat]', selectedSize);

      // Shopify analytics custom event
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        Shopify.analytics.publish('fassfactory:lightfoto_added_to_cart', {
          product: 'Light Foto',
          variant_id: chosenVariant,
          variant_label: selectedSize,
          frame_color_name: selectedFrameName,
          frame_color_hex: selectedFrameColor,
          has_upload: true,
          quantity: 1
        });
      }

      form.setAttribute('enctype', 'multipart/form-data');
      form.setAttribute('encoding', 'multipart/form-data');
      form.submit();
    }

    if (pickBtn && file1) {
      pickBtn.addEventListener('click', () => file1.click());
    }

    if (file1) {
      file1.addEventListener('change', async () => {
        const file = file1.files && file1.files[0];
        if (!file) {
          if (fileNameEl) fileNameEl.textContent = 'Geen bestand gekozen';
          resetPhoto();
          return;
        }

        if (fileNameEl) fileNameEl.textContent = file.name;
        await readPreview(file);
      });
    }

    addBtn.addEventListener('click', addToCart);
    if (removeBtn) removeBtn.addEventListener('click', resetPhoto);

    validate();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lf]').forEach(init);
  });
})();